import { COLUMNS } from './columns';

export { COLUMNS };
